import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Component, OnInit, Input } from "@angular/core";
import { ProjectService } from "apps/resource-portal/src/app/services/project.service";
import { AuthService } from "apps/resource-portal/src/app/services/auth.service";
import { EMPTY_GUID } from "apps/resource-portal/src/app/constants/app.constant";
import { CutSheetService } from "apps/resource-portal/src/app/services/cut-sheet.service";
import { firstValueFrom } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
  selector: "concourse-cutsheet-images",
  templateUrl: "./cutsheet-images.component.html",
  styleUrls: ["./cutsheet-images.component.scss"],
})
export class CutsheetImagesComponent implements OnInit {
  @Input() projectId: string = EMPTY_GUID;
  @Input() jsnId: string = EMPTY_GUID;
  @Input() projectName: string = "";

  // Component State Properties
  selectedProject: any = EMPTY_GUID;
  sourceImages: string[] = [];
  selectedImages: (string | null)[] = new Array(7).fill(null);
  draggedImage: string | null = null;
  draggedIndex: number | null = null;
  projects: any[] = [];
  jsnProjects: any[] = [];
  isJsnIndividual: boolean = true;
  user: any;
  jsnName: any;
  jsnOther: any = "";
  EMPTY_GUID: string = EMPTY_GUID;

  // Properties for Deletion and State Tracking
  cutsheetData: any;
  originalImagesByIndex: { [index: number]: { id: string; url: string } } = {};
  imagesToDelete: Map<string, any> = new Map();
  images: any = {};

  constructor(
    public activeModal: NgbActiveModal,
    private _projectService: ProjectService,
    private _cutsheetService: CutSheetService,
    private _authService: AuthService,
    private _toastService: ToastrService,
    private sanitizer: DomSanitizer,

  ) { }

  ngOnInit(): void {
    this.user = this._authService.$user.value;
    this.getJsnDetails();
  }
  private initializeImages(): void {
    for (let i = 1; i <= 7; i++) {
      this.images[`image${i}`] = { url: null, blob: null, id: null, title: null };
    }
  }
  private async urlToBlob(imageUrl: string): Promise<Blob> {
    const response = await fetch(imageUrl);
    return response.blob();
  }

  getJsnDetails() {
    this._cutsheetService
      .getCutsheetDetailByCutsheetId(this.jsnId)
      .subscribe(async (res) => {
        if (!res) return
        // Store the entire response for later use
        this.cutsheetData = res;
        console.log('cutsheet==>', res);

        this.jsnName = this.cutsheetData.name;
        this.jsnOther = this.cutsheetData.jsnother;
        this.projectName = this.cutsheetData.project.projectname;

        this.initializeImages()
        for (let i = 1; i <= 7; i++) {
          const imageUrl = res?.[`image${i}url`] || null;
          const imageId = res?.[`image${i}id`] || null;

          let imageTitle
          if (i == 1) {
            imageTitle = res?.[`mainimagetitle`] || null;

          } else {
            imageTitle = res?.[`finish${i - 1}imagetitle`] || null;
          }


          this.images[`image${i}`] = {
            url: imageUrl,
            blob: imageUrl ? await this.urlToBlob(imageUrl) : null,
            id: imageId,
            title: imageTitle || 'N/A'
          }
        }
        console.log(this.images);


        // OG
        // Reset state for a fresh load
        this.imagesToDelete.clear();


        this.getAllProjects();
        this.getJsnImages();

      });
  }

  removeImage(i: number) {
    if (this.images['image' + i].id != EMPTY_GUID && this.images['image' + i].id != null) {
      this.imagesToDelete.set(this.images['image' + i].id, this.images['image' + i].url);
    }
    this.images['image' + i] = { url: null, blob: null, id: null, title: null };
  }

  onImageUpload(event: any, index: number) {
    const file = event.target.files[0];
    if (!file) return
    const reader = new FileReader();
    reader.onload = async () => {
      const imageUrl = reader.result as string;
      this.images[`image${index}`] = {
        url: imageUrl,
        blob: await this.urlToBlob(imageUrl),
        id: EMPTY_GUID,
        title: 'Image ' + index
      };
    };
    reader.readAsDataURL(file);
  }

  async onDrop(event, i: number) {
    event.preventDefault();

    if (this.draggedImage !== null) {
      if (this.draggedIndex === null) {
        // Dragged from source
        if (this.images['image' + i] !== EMPTY_GUID) {
          this.removeImage(i)
        }
        this.images['image' + i] =
          { url: this.draggedImage, blob: await this.urlToBlob(this.draggedImage), id: EMPTY_GUID, title: 'Image' + i }
      } else if (this.draggedIndex !== i) {
        // Reordering

        // create temp
        const temp = this.images['image' + i]
        if (temp.id != EMPTY_GUID || temp.id != null) {
          this.removeImage(i)
          temp.id = EMPTY_GUID
        }

        // swap
        this.images['image' + i] = { url: this.draggedImage, blob: await this.urlToBlob(this.draggedImage), id: EMPTY_GUID, title: 'Image' + i };
        if (this.images['image' + this.draggedIndex].id != EMPTY_GUID || this.images['image' + this.draggedIndex].id != null) {
          this.removeImage(this.draggedIndex)
        }

        this.images['image' + this.draggedIndex] = temp;
      }
      this.draggedImage = null;
      this.draggedIndex = null;
    } else if (event.dataTransfer && event.dataTransfer.items.length > 0) {

      const fileItems = Array.from(event.dataTransfer.items).filter((item: DataTransferItem) => item.kind === 'file');
      const item: DataTransferItem = fileItems[0] as any


      // Handle if user drags image file from disk
      if (item.kind == 'file') {
        const file = item.getAsFile();
        if (file && file.type.startsWith('image/')) {
          const url = URL.createObjectURL(file);
          this.images['image' + i] = {
            url,
            blob: file,
            id: EMPTY_GUID,
            title: 'Image' + i,
          };
          return;
        }
      }

      // Handle if user drags image from another browser tab (HTML img or link)
      const url = event.dataTransfer.getData('text/uri-list') || event.dataTransfer.getData('text/plain');
      if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
        const blob = await this.urlToBlob(url);
        this.images['image' + i] = {
          url,
          blob,
          id: EMPTY_GUID,
          title: 'Image' + i,
        };
        return;
      }
    }




  }

  async save() {
    console.log('delete==>', this.imagesToDelete);
    console.log('images==>', this.images);


    try {
      let operationsPerformed = false;

      //   // --- STEP 1: Process Deletions ---
      if (this.imagesToDelete.size > 0) {
        operationsPerformed = true;
        console.log(
          `Preparing to delete ${this.imagesToDelete.size} image(s).`
        );
        const deletePromises: Promise<any>[] = [];

        const payload = {
          annotationimage: Object.fromEntries(this.imagesToDelete),
          jsnother: this.cutsheetData.jsnother,
          jsn: this.cutsheetData.id,
          name: this.cutsheetData.name,
          project: this.cutsheetData.project.id,
        };
        const deleteRequest = this._cutsheetService.deleteImage(payload);
        deletePromises.push(firstValueFrom(deleteRequest));
        await Promise.all(deletePromises);
        console.log("All marked images have been successfully deleted.");
      }

      //--- STEP 2: Process Only NEW Images for Upload ---
      const formData = new FormData();
      formData.append("jsn", this.jsnId);
      formData.append("validate", "false");
      formData.append("project", this.projectId);

      for (let i = 1; i <= 7; i++) {
        const image = this.images[`image${i}`];
        if (image.url && image.id == EMPTY_GUID && image.blob) {
          formData.append(`img${i}`, image.blob, `upload_${Date.now()}_${i}.png`);
        }
        if (i == 1) {
          formData.append('mainimagetitle', image.title)
        } else {
          formData.append(`finish${i - 1}imagetitle`, image.title)
        }
      }
      this._cutsheetService.saveJsn(formData).subscribe({
        next: (res) => {
          console.log("New images saved successfully:", res);
          this._toastService.success('Images were uploaded successfully. They should appear within a minute')
          this.activeModal.close("saved");
        },
        error: (err) => console.error("Failed to save new images:", err),
      });

      // if (imageBlobs.length > 0) {
      //   this._cutsheetService.saveJsn(formData).subscribe({
      //     next: (res) => {
      //       console.log("New images saved successfully:", res);
      //       this._toastService.success('Images were uploaded successfully. They should appear within a minute')
      //       this.activeModal.close("saved");
      //     },
      //     error: (err) => console.error("Failed to save new images:", err),
      //   });
      // } else {
      //   console.log("No new images to upload.");
      //   if (operationsPerformed) {
      //     this._toastService.success('No new images to upload')
      //     this.activeModal.close("saved");
      //   }
      // }
    } catch (error) {
      console.error("An error occurred during the save process:", error);
    }
  }

  onToggleChange(): void {
    this.getAllProjects();
  }

  selectEvent(event: any) {
    // this.selectedProject = event.id || EMPTY_GUID;
    this.selectedProject = event.target.value || EMPTY_GUID;

    this.getJsnImages();
  }

  getJsnImages() {
    let params = {
      project: this.selectedProject || EMPTY_GUID,
      isjsnindividual: this.isJsnIndividual,
      name: this.jsnName,
      suffix: this.jsnOther || "",
      currentjsn: this.jsnId
    };
    this._cutsheetService.getJsnByNameType(params).subscribe((res) => {
      this.jsnProjects = res.sort((a, b) => {
        const nameA = a.jsn.project.projectname;
        const nameB = b.jsn.project.projectname;
        return nameA.localeCompare(nameB);
      });
    });
  }

  getAllProjects() {
    this.projects = [];
    let payload = {
      isjsnindividual: this.isJsnIndividual,
      name: this.jsnName,
      suffix: this.jsnOther || "",
      currentjsn: this.jsnId
    };
    this._projectService
      .getJsnProjectList(payload)
      .pipe()
      .subscribe((res: any) => {
        this.projects = res.data;

        const selectedProjectExists = this.projects.some(
          (p) => p.id == this.selectedProject
        );
        if (!selectedProjectExists) {
          this.selectedProject = EMPTY_GUID;
        }
        this.getJsnImages();
      });
  }

  onDragStart(event: any, image: any) {
    const imageUrl = image.value || image;
    this.draggedImage = imageUrl;
    this.draggedIndex = null;
    event.dataTransfer?.setData("text/plain", imageUrl);
  }

  onSelectedImageDragStart(event: any, i: number) {
    this.draggedImage = this.images['image' + i].url;
    this.draggedIndex = i;
    event.dataTransfer?.setData("text/plain", this.images['image' + i].url || "");
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  async convertImageToBlob(imageSource: string): Promise<Blob> {
    const response = await fetch(imageSource);
    return await response.blob();
  }
  sanitizeImage(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }
}
